import {
    LIST_USER_INTERNAL_REQUEST,
    LIST_USER_INTERNAL_SUCCESS,
    LIST_USER_INTERNAL_FAIL,
    LIST_USER_INTERNAL_SUMMARY_REQUEST,
    LIST_USER_INTERNAL_SUMMARY_SUCCESS,
    LIST_USER_INTERNAL_SUMMARY_FAIL,
    CREATE_USER_INTERNAL_REQUEST,
    CREATE_USER_INTERNAL_SUCCESS,
    CREATE_USER_INTERNAL_FAIL,
    DETAIL_USER_INTERNAL_REQUEST,
    DETAIL_USER_INTERNAL_SUCCESS,
    DETAIL_USER_INTERNAL_FAIL,
    UPDATE_USER_INTERNAL_REQUEST,
    UPDATE_USER_INTERNAL_SUCCESS,
    UPDATE_USER_INTERNAL_FAIL,
    UPDATE_PASSWORD_USER_INTERNAL_REQUEST,
    UPDATE_PASSWORD_USER_INTERNAL_SUCCESS,
    UPDATE_PASSWORD_USER_INTERNAL_FAIL,
    DELETE_USER_INTERNAL_REQUEST,
    DELETE_USER_INTERNAL_SUCCESS,
    DELETE_USER_INTERNAL_FAIL,
    LIST_USER_INTERNAL_BRANCH_REQUEST,
    LIST_USER_INTERNAL_BRANCH_SUCCESS,
    LIST_USER_INTERNAL_BRANCH_FAIL,
    SET_MAIN_USER_INTERNAL_BRANCH_REQUEST,
    SET_MAIN_USER_INTERNAL_BRANCH_SUCCESS,
    SET_MAIN_USER_INTERNAL_BRANCH_FAIL,
    USER_INTERNAL_RESET
} from '../../constants/users'

const initialState = {
    loading: false,
    loadingDetail: false,
    loadingUpdate: false,
    loadingUpdateMain: false,
    usersInternal: [],
    usersInternalBranch: [],
    userInternal: {},
    usersInternalSummary: [],
    error: null,
    status: '',
    message: '',
    pageable: {}
}

const usersInternalReducer = (state = initialState, action) => {
    switch (action.type) {

        // Internal
        case LIST_USER_INTERNAL_REQUEST:
            return { ...state, loading: true }
        case LIST_USER_INTERNAL_SUCCESS:
            return { ...state, loading: false, usersInternal: action.payload, pageable: action.pageable }
        case LIST_USER_INTERNAL_FAIL:
            return { ...state, loading: false, error: action.payload, usersInternal: [] }
        case LIST_USER_INTERNAL_SUMMARY_REQUEST:
            return { ...state, loading: true }
        case LIST_USER_INTERNAL_SUMMARY_SUCCESS:
            return { ...state, loading: false, usersInternalSummary: action.payload }
        case LIST_USER_INTERNAL_SUMMARY_FAIL:
            return { ...state, loading: false, error: action.payload, usersInternalSummary: [] }
        case LIST_USER_INTERNAL_SUMMARY_FAIL:
        case USER_INTERNAL_RESET:
            return { ...state, usersInternal: [] }
        case DETAIL_USER_INTERNAL_REQUEST:
            return { ...state, loadingDetail: true }
        case DETAIL_USER_INTERNAL_SUCCESS:
            return { ...state, loadingDetail: false, userInternal: action.payload }
        case DETAIL_USER_INTERNAL_FAIL:
            return { ...state, loadingDetail: false, error: action.payload }
        case CREATE_USER_INTERNAL_REQUEST:
            return { ...state, loading: true }
        case CREATE_USER_INTERNAL_SUCCESS:
            const newUser = action.payload
            const usersDataCreate = [...state?.usersInternal]
            usersDataCreate.push(newUser)

            return { ...state, loading: false, success: true, usersInternal: usersDataCreate }
        case CREATE_USER_INTERNAL_FAIL:
            return { ...state, loading: false, error: action.payload }
        case UPDATE_USER_INTERNAL_REQUEST:
            return { ...state, loadingUpdate: true }
        case UPDATE_USER_INTERNAL_SUCCESS:
            const usersData = [...state?.usersInternal]
            const index = usersData.findIndex(user => user.id === action.payload.id)
            usersData[index] = action.payload

            return { ...state, loadingUpdate: false, success: true, usersInternal: usersData }
        case UPDATE_USER_INTERNAL_FAIL:
            return { ...state, loadingUpdate: false, error: action.payload }
        case UPDATE_PASSWORD_USER_INTERNAL_REQUEST:
            return { ...state, loadingUpdate: true }
        case UPDATE_PASSWORD_USER_INTERNAL_SUCCESS:
            return { ...state, loadingUpdate: false, success: true, error: null }
        case UPDATE_PASSWORD_USER_INTERNAL_FAIL:
            return { ...state, loadingUpdate: false, error: action.payload, success: false }
        case DELETE_USER_INTERNAL_REQUEST:
            return { ...state, loading: true }
        case DELETE_USER_INTERNAL_SUCCESS:
            const usersDataDelete = [...state?.usersInternal]
            const indexDelete = usersDataDelete.findIndex(user => user.id === action.payload)
            usersDataDelete.splice(indexDelete, 1)

            return { ...state, loading: false, success: true, usersInternal: usersDataDelete }
        case DELETE_USER_INTERNAL_FAIL:
            return { ...state, loading: false, error: action.payload }
        case LIST_USER_INTERNAL_BRANCH_REQUEST:
            return { ...state, loading: true }
        case LIST_USER_INTERNAL_BRANCH_SUCCESS:
            return { ...state, loading: false, usersInternalBranch: action.payload, error: null }
        case LIST_USER_INTERNAL_BRANCH_FAIL:
            return { ...state, loading: false, error: action.payload, usersInternalBranch: action.dummy }
        case SET_MAIN_USER_INTERNAL_BRANCH_REQUEST:
            return { ...state, loadingUpdateMain: true }
        case SET_MAIN_USER_INTERNAL_BRANCH_SUCCESS:
            return { ...state, loadingUpdateMain: false, error: null }
        case SET_MAIN_USER_INTERNAL_BRANCH_FAIL:
            return { ...state, loadingUpdateMain: false, error: action.payload }
        case USER_INTERNAL_RESET:
            return { ...state, usersInternal: [] }
        default:
            return state
    }
}

export default usersInternalReducer
